import angular from 'angular'

/**
 * A fixed position bar at the top of the page to host the top navigation.
 */
angular.module('vend.ui').directive('vdTopbar', function () {
  return {
    link(scope, $element, attrs) {
      attrs.$addClass('vd-topbar')
      attrs.$set('role', 'navigation')
    },
  }
})
